var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhoneSmall = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12.4C15.8 12.4 14.6 12.2 13.5 11.8C13.1 11.7 12.8 11.8 12.5 12L10.9 14C8.1 12.7 5.4 10.1 4 7.2L6 5.5C6.3 5.2 6.4 4.8 6.2 4.5C5.8 3.4 5.6 2.2 5.6 1C5.6 0.5 5.2 0 4.6 0H1.2C0.7 0 0 0.2 0 1C0 10.3 7.7 18 17 18C17.7 18 18 17.4 18 16.8V13.4C18 12.8 17.5 12.4 17 12.4Z",
    fill: "#072636"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhoneSmall);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone_small.95f3bdad7a85051c480ca18f6d796983.svg";